import { historicalMatchDetailParamsSchema } from '@ballpeek/api/client'
import { createFileRoute, redirect } from '@tanstack/react-router'

import { HistoricalMatchPage } from '~/features/football-history/history-pages'
import { canonicalMatchHref } from '~/features/football-history/links'
import { historicalMatchQueryOptions } from '~/features/football-history/query-options'
import { parseHistoricalMatchSearch } from '~/features/football-history/search-schema'
import { parseMatchDetailSearch } from '~/features/football-match-detail/back-navigation'
import { parsePublicFootballRouteInput } from '~/lib/public-football-read'
import { seo } from '~/utils/seo'

export const Route = createFileRoute('/_public/history/matches/$historicalMatchId')({
  validateSearch: search => parseHistoricalMatchSearch(search, 'en'),
  beforeLoad: ({ params }) => {
    parsePublicFootballRouteInput(historicalMatchDetailParamsSchema, params)
  },
  head: ({ params }) => seo({
    title: 'Historical Match Detail | BallPeek',
    description: 'Descriptive historical football record with bounded source and field coverage.',
    pathname: `/history/matches/${encodeURIComponent(params.historicalMatchId)}`,
    locale: 'en',
  }),
  loader: async ({ context, params, location }) => {
    const result = await context.queryClient
      .fetchQuery(historicalMatchQueryOptions(params.historicalMatchId))
      .catch(() => null)
    if (result?.kind === 'canonical') {
      const search = parseMatchDetailSearch(location.search, 'en')
      throw redirect({ href: canonicalMatchHref('en', result.matchId, search.back ?? '/matches') })
    }
  },
  component: HistoricalMatchRoute,
})

function HistoricalMatchRoute() {
  const params = Route.useParams()
  return (
    <HistoricalMatchPage
      historicalMatchId={params.historicalMatchId}
      back={Route.useSearch().back}
    />
  )
}
